import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { FooterLayoutComponent } from './shared/layout/footer-layout/footer-layout.component';
import { PageMaintenanceComponent } from './components/common/page-maintenance/page-maintenance.component';
import { PageNotFoundComponent } from './components/common/page-not-found/page-not-found.component';
import { GlobalSearchResultComponent } from './shared/layout/global-search-result/global-search-result.component';

export const APP_ROUTES: Routes = [
  { path: 'failure', loadChildren: () => import('./modules/failure/failure.module').then(m => m.FaultModule) },
  { path: 'admin', loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule) },
  { path: 'user', loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule) },
  { path: 'search', component: GlobalSearchResultComponent }
]
export const FOOTER_ROUTES: Routes = [
  { path: 'maintenance', component: PageMaintenanceComponent },
  { path: '**', component: PageNotFoundComponent }
]

const routes: Routes = [
  // { path: '', component: AppLayoutComponent, canActivate: [MsalGuard], children: APP_ROUTES, resolve: { Identity: ResolveIdentity } },
  { path: '', component: AppLayoutComponent, canActivate: [MsalGuard], children: APP_ROUTES },
  { path: '', component: FooterLayoutComponent, children: FOOTER_ROUTES }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false, enableTracing: false,
      scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled',
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
